export enum CheckFrequency {
  LOW = "10-LOW",
  MEDIUM = "20-MEDIUM",
  HIGH = "30-HIGH",
}

export const MonitoringFrequencyName = {
  [CheckFrequency.LOW]: "5 Mins",
  [CheckFrequency.MEDIUM]: "1 Min",
  [CheckFrequency.HIGH]: "1 Min",
};
